import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * alpha-team
 * CLOUDWEB-18023: Качество. PDF-редактор. Промо редактирования страниц внутри редактора
 */
export const pdfWorkWithPagesPromoFeature: boolean = getFeature('pdf-work-with-pages-promo');
